import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common-services/common.service';
export interface Speaker {
  id: number;
  name: string;
  department: string;
  image: string;
}
export interface Events {
  id: number;
  name: string;
  date: string;
  venue: string;
  image:string;
  description:string;
  expire:boolean;
}
@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent {
  constructor(private router: Router, private commonService: CommonService){
  }
  ngOnInit(): void {
  }
  
}
